var _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Use, Mask, Path, Defs, LinearGradient, Stop } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */
var SvgHudRailShell = function SvgHudRailShell(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 122,
    height: 328,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 122 328"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    filter: "url(#hud-rail-shell_svg__a)"
  }, /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#hud-rail-shell_svg__b",
    fill: "url(#hud-rail-shell_svg__c)"
  }), /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#hud-rail-shell_svg__b",
    fill: "url(#hud-rail-shell_svg__d)"
  }), /*#__PURE__*/React.createElement(Mask, {
    id: "hud-rail-shell_svg__e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#hud-rail-shell_svg__b"
  })), /*#__PURE__*/React.createElement(Path, {
    stroke: "#42C8FF",
    strokeWidth: 2,
    d: "M36 16h34c8.84 0 16 7.16 16 16v90c0 11 16 11 16 20v32c0 9-16 9-16 20v90c0 8.84-7.16 16-16 16H36c-8.84 0-16-7.16-16-16V32c0-8.84 7.16-16 16-16Z",
    mask: "url(#hud-rail-shell_svg__e)"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "hud-rail-shell_svg__c",
    x1: 61,
    x2: 61,
    y1: 16,
    y2: 300,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#0C2037"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.78,
    stopColor: "#061322"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#061322"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "hud-rail-shell_svg__d",
    x1: 61,
    x2: 61,
    y1: 16,
    y2: 300,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#fff",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.45,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement(Path, {
    id: "hud-rail-shell_svg__b",
    d: "M36 16h34c8.84 0 16 7.16 16 16v90c0 11 16 11 16 20v32c0 9-16 9-16 20v90c0 8.84-7.16 16-16 16H36c-8.84 0-16-7.16-16-16V32c0-8.84 7.16-16 16-16"
  }))));
};
export default SvgHudRailShell;